import React from "react";
import SkillGeneralInfo from "../GeneralInfo";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";

const SkillDetails = (props) => {
  const handleReturn = () => {
    props.history.push(`/skills`);
  };
  return (
    <CardContainer
      header={"Skill Details"}
      backButton={
        <ButtonInput
          label="Back to List"
          type="button"
          variant={BootstrapVariants.OutlineSecondary}
          onClick={() => handleReturn()}
        />
      }
    >
      <SkillGeneralInfo skillId={props.match.params.skillId} />
    </CardContainer>
  );
};

export default SkillDetails;
